import type {
	TradingAccount,
	TradingAccountCreate,
	TradingAccountUpdate,
	TradingPosition,
	TradingPositionUpdate,
	TradingStats,
	TradingTradeInput
} from '@andresot/protocol/trading';
import { request } from './client.js';

export function fetchAccounts(): Promise<{ accounts: TradingAccount[] }> {
	return request('/api/trading/accounts');
}

export function createAccount(
	input: TradingAccountCreate
): Promise<{ accounts: TradingAccount[] }> {
	return request('/api/trading/accounts', { body: input });
}

export function updateAccount(
	accountId: string,
	input: TradingAccountUpdate
): Promise<{ accounts: TradingAccount[] }> {
	return request(`/api/trading/accounts/${accountId}`, { method: 'PATCH', body: input });
}

export function deleteAccount(accountId: string): Promise<{ accounts: TradingAccount[] }> {
	return request(`/api/trading/accounts/${accountId}`, { method: 'DELETE' });
}

export function fetchPositions(
	accountId: string,
	status: 'open' | 'closed' | 'all' = 'all'
): Promise<{ positions: TradingPosition[] }> {
	return request(`/api/trading/accounts/${accountId}/positions?status=${status}`);
}

export function openPosition(
	accountId: string,
	input: {
		symbol: string;
		targetPrice?: string;
		stopPrice?: string;
		note?: string;
		tags?: string[];
		trade: TradingTradeInput;
	}
): Promise<{ position: TradingPosition }> {
	return request(`/api/trading/accounts/${accountId}/positions`, { body: input });
}

export function updatePosition(
	positionId: string,
	input: TradingPositionUpdate
): Promise<{ position: TradingPosition }> {
	return request(`/api/trading/positions/${positionId}`, { method: 'PATCH', body: input });
}

export function deletePosition(positionId: string): Promise<{ ok: true }> {
	return request(`/api/trading/positions/${positionId}`, { method: 'DELETE' });
}

export function addTrade(
	positionId: string,
	input: TradingTradeInput
): Promise<{ position: TradingPosition }> {
	return request(`/api/trading/positions/${positionId}/trades`, { body: input });
}

export function deleteTrade(tradeId: string): Promise<{ ok: true }> {
	return request(`/api/trading/trades/${tradeId}`, { method: 'DELETE' });
}

export function fetchStats(accountId: string): Promise<{ stats: TradingStats }> {
	return request(`/api/trading/accounts/${accountId}/stats`);
}
